import { useSelector } from "react-redux";
import { typeNotificationIcon } from "../../../../typeNotifications";

const CorePushNotifications = ({ notifica }) => {
  const role = useSelector((state) => state.app.role);

  const { icon, label } = typeNotificationIcon(JSON.parse(notifica).type, role);

  return (
    <div
      className="flex justify-center items-center space-x-4"
      style={{ fontWeight: "bold" }}
    >
      {icon}
      <small>{label}</small>
    </div>
  );
};

export default CorePushNotifications;
